import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { OrdersService } from './orders.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  baskets: any = [];
  basketsUpdated = new Subject<any>();

  leaves: any = [];
  leavesUpdated = new Subject<any>();

  dressings: any = [];
  dressingsUpdated = new Subject<any>();

  price: number = 0;
  priceUpdated = new Subject<number>();

  totalObj = {
    total: 0,
    subtotal: 0,
    fees: [],
    oneDeliveryTotal: 0
  }

  totalObjUpdated = new Subject<any>();

  isProduct: Boolean;

  totalCount: number = 0;
  totalCountUpdated = new Subject<number>();

  private subscriptionButtonChange = new Subject<boolean>();
  private couponStatusUpdated = new Subject<boolean>();

  constructor(private ordersService: OrdersService, private snackBar: MatSnackBar) { }

  getBasketsUpdated() {
    return this.basketsUpdated.asObservable();
  }

  getLeavesUpdated() {
    return this.leavesUpdated.asObservable();
  }

  getDressingsUpdated() {
    return this.dressingsUpdated.asObservable();
  }

  getPriceUpdated() {
    return this.priceUpdated.asObservable();
  }

  getTotalObjUpdated() {
    return this.totalObjUpdated.asObservable();
  }

  getTotalCountUpdated() {
    return this.totalCountUpdated.asObservable();
  }

  setSubscriptionButtonChange(data: boolean) {
    this.subscriptionButtonChange.next(data);
  }

  getSubscriptionButtonChanged() {
    return this.subscriptionButtonChange.asObservable()
  }

  setCouponStatus(data) {
    this.couponStatusUpdated.next(data);
  }

  getCouponStatusUpdated() {
    return this.couponStatusUpdated.asObservable();
  }

  onLoad() {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    this.onTotalItemCount();
    this.onCalculatePrice();

    const onLoadData = {
      baskets: this.baskets,
      leaves: this.leaves,
      dressings: this.dressings,
      price: this.price,
      totalCount: this.totalCount,
      totalObj: this.totalObj
    }

    return onLoadData;
  }

  addToCart(data) {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.checkForExistence(data._id);

    if (this.isProduct) {

      if (data.category === 'Leaves') {
        this.increaseQuantity(data._id, 'leaves');
      } else if (data.category === 'Dressings') {
        this.increaseQuantity(data._id, 'dressings');
      } else {
        this.increaseQuantity(data._id, 'basket');
      }

      this.isProduct = false;
      return;
    }

    if (data.category === 'Leaves') { // if category is leaves

      if (localLeaves) {
        this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
        this.leaves.push(data); // push data to leaves array
        this.leavesUpdated.next(this.leaves); // push new leaevs to the subject
      } else {
        this.leaves = []; // initiate array 
        this.leaves.push(data); // push data to leaves array
        this.leavesUpdated.next(this.leaves); // push new leaves to the subject
      }
      localStorage.setItem('leaves', JSON.stringify(this.leaves)); // store leaves in local storage
      this.onTotalItemCount();
      this.onCalculatePrice();

    } else if (data.category === 'Dressings') {

      if (localDressings) {

        this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

        this.dressings.push(data); // push data to dressings array
        this.dressingsUpdated.next(this.dressings); // push new dressings to the subject

      } else {

        this.dressings = []; // initiate array 
        this.dressings.push(data); // push data to dressings array
        this.dressingsUpdated.next(this.dressings); // push new dressings to the subject
      }

      localStorage.setItem('dressings', JSON.stringify(this.dressings)); // store dressings in local storage
      this.onTotalItemCount();
      this.onCalculatePrice();

    } else {

      if (localBaskets) {

        this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON

        this.baskets.push(data); // push data to baskets array
        this.basketsUpdated.next(this.baskets); // push new baskets to the subject

      } else {

        this.baskets = []; // initiate array 

        this.baskets.push(data); // push data to baskets array
        this.basketsUpdated.next(this.baskets); // push new baskets to the subject
      }

      localStorage.setItem('baskets', JSON.stringify(this.baskets)); // store baskets in local storage
      this.onTotalItemCount();
      this.onCalculatePrice();
    }
  }

  remove(Type: string) { // remove items from cart based on the type provided

    if (Type === 'basket') {
      localStorage.removeItem('baskets');
      this.baskets = [];
      this.basketsUpdated.next(this.baskets);
      this.onTotalItemCount();
      this.onCalculatePrice();
    } else if (Type === 'leaves') {
      localStorage.removeItem('leaves');
      this.leaves = [];
      this.leavesUpdated.next(this.leaves);
      this.onTotalItemCount();
      this.onCalculatePrice();
    } else if (Type === 'dressings') {
      localStorage.removeItem('dressings');
      this.dressings = [];
      this.dressingsUpdated.next(this.dressings);
      this.onTotalItemCount();
      this.onCalculatePrice();
    }
  }

  removeAll() {
    localStorage.removeItem('baskets');
    localStorage.removeItem('leaves');
    localStorage.removeItem('dressings');
    localStorage.setItem('subscriptionType', 'One Delivery');

    this.baskets = [];
    this.leaves = [];
    this.dressings = [];

    this.basketsUpdated.next(this.baskets);
    this.leavesUpdated.next(this.leaves);
    this.dressingsUpdated.next(this.dressings);

    this.onTotalItemCount();
    this.onCalculatePrice();
  }

  // calculate price using orders calculate price service
  private onCalculatePrice() {

    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    const couponCode = localStorage.getItem('coupon'); // get local coupon code

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    const subscriptionType = localStorage.getItem('subscriptionType');

    let arrangedBaskets = [];
    let arrangedProducts = [];

    if (localBaskets) {
      this.baskets.map(basket => {
        const data = {
          _id: basket._id,
          quantity: basket.quantity
        }
        arrangedBaskets.push(data)
      })
    }

    if (localLeaves) {
      this.leaves.map(leave => {
        const data = {
          _id: leave._id,
          quantity: leave.quantity
        }
        arrangedProducts.push(data)
      })
    }

    if (localDressings) {
      this.dressings.map(dressing => {
        const data = {
          _id: dressing._id,
          quantity: dressing.quantity
        }
        arrangedProducts.push(data)
      })
    }

    let data = {
      baskets: arrangedBaskets,
      orderType: subscriptionType,
      products: arrangedProducts
    }

    if (data.baskets.length === 0 && data.products.length === 0) {
      this.price = 0;
      this.totalObj.total = 0;
      this.totalObj.subtotal = 0;
      this.totalObj.fees = [];
      this.totalObj.oneDeliveryTotal = 0;

      this.priceUpdated.next(this.price);
      this.totalObjUpdated.next(this.totalObj);
      return;
    }

    const user = JSON.parse(localStorage.getItem('user'))

    const formData = new FormData();
    formData.append('baskets', JSON.stringify(arrangedBaskets));
    formData.append('orderType', subscriptionType);
    formData.append('products', JSON.stringify(arrangedProducts));

    if (user != null && user.userType === 'User') {
      formData.append('user', user._id);
    }

    if (couponCode != null) {
      formData.append('couponCode', couponCode);
    }

    this.ordersService.calculatePrice(formData).subscribe(result => {
      if (result.data.couponAdded) {
        this.couponStatusUpdated.next(true);
      }

      this.price = result.data.total;
      this.totalObj.total = result.data.total;
      this.totalObj.subtotal = result.data.subtotal;
      this.totalObj.fees = result.data.fees;
      this.totalObj.oneDeliveryTotal = result.data.oneDeliveryTotal;

      this.priceUpdated.next(this.price);
      this.totalObjUpdated.next(this.totalObj);
    }, error => {
      if (error.error.data.couponFailed) {
        localStorage.removeItem('coupon');
        this.snackBar.open(error.error.data.message, 'Dismiss', {
          duration: 3000
        });
      } else {
        this.snackBar.open(error.error.data, 'Dismiss', {
          duration: 3000
        });
      }
    });
  }

  // check for existing items
  private checkForExistence(ID) {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    if (this.baskets) {
      this.baskets.map((basket) => {
        if (basket._id === ID) {
          this.isProduct = true;
        }
      })
    }

    if (this.leaves) {
      this.leaves.map((leave) => {
        if (leave._id === ID) {
          this.isProduct = true;
        }
      })
    }

    if (this.dressings) {
      this.dressings.map((dressing) => {
        if (dressing._id === ID) {
          this.isProduct = true;
        }
      })
    }
  }

  // increase quantity
  increaseQuantity(ID, Type) {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    if (Type == 'basket' && localBaskets) {
      this.baskets.map(basket => {
        if (basket._id === ID) {
          basket.quantity += 1;
        }
      });

      this.basketsUpdated.next(this.baskets);
      localStorage.setItem('baskets', JSON.stringify(this.baskets));
      this.onCalculatePrice();
    }

    if (Type == 'leaves' && localLeaves) {
      this.leaves.map(leave => {
        if (leave._id === ID) {
          leave.quantity += 1;
        }
      });

      this.leavesUpdated.next(this.leaves);
      localStorage.setItem('leaves', JSON.stringify(this.leaves));
      this.onCalculatePrice();
    }

    if (Type == 'dressings' && localDressings) {
      this.dressings.map(dressing => {
        if (dressing._id === ID) {
          dressing.quantity += 1;
        }
      });

      this.dressingsUpdated.next(this.dressings);
      localStorage.setItem('dressings', JSON.stringify(this.dressings));
      this.onCalculatePrice();
    }
  }

  // decrease quantity
  decreaseQuantity(ID, Type) {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    if (Type == 'basket' && localBaskets) {
      this.baskets.map(basket => {
        if (basket._id === ID) {
          if (basket.quantity === 1) {
            this.baskets = this.baskets.filter(basket => basket._id !== ID);
          }
          basket.quantity -= 1;
        }
      })

      this.basketsUpdated.next(this.baskets);
      localStorage.setItem('baskets', JSON.stringify(this.baskets));
      this.onTotalItemCount();
      this.onCalculatePrice();
    }

    if (Type == 'leaves' && localLeaves) {
      this.leaves.map(leave => {
        if (leave._id === ID) {
          if (leave.quantity === 1) {
            this.leaves = this.leaves.filter(leave => leave._id !== ID);
          }
          leave.quantity -= 1;
        }
      })

      this.leavesUpdated.next(this.leaves);
      localStorage.setItem('leaves', JSON.stringify(this.leaves));
      this.onTotalItemCount();
      this.onCalculatePrice();
    }

    if (Type == 'dressings' && localDressings) {
      this.dressings.map(dressing => {
        if (dressing._id === ID) {
          if (dressing.quantity === 1) {
            this.dressings = this.dressings.filter(dressing => dressing._id !== ID);
          }
          dressing.quantity -= 1;
        }
      })

      this.dressingsUpdated.next(this.dressings);
      localStorage.setItem('dressings', JSON.stringify(this.dressings));
      this.onTotalItemCount();
      this.onCalculatePrice();
    }
  }

  // on subscription type change
  onSubscriptionTypeChange() {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    if (!localBaskets && !localLeaves && !localDressings) {
      this.snackBar.open('Cart is empty!', 'Dismiss', {
        duration: 3000
      })
      return;
    }

    this.onCalculatePrice();
  }

  onApplyCoupon() {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON

    if (!localBaskets && !localLeaves && !localDressings) {
      this.snackBar.open('Cart is empty!', 'Dismiss', {
        duration: 3000
      })
      return;
    }

    this.onCalculatePrice();
  }

  // count total items
  onTotalItemCount() {
    const localBaskets = localStorage.getItem('baskets'); // get local basket array
    const localLeaves = localStorage.getItem('leaves'); // get local products array
    const localDressings = localStorage.getItem('dressings'); // get local products array

    this.baskets = JSON.parse(localBaskets); // convert local storage string ot JSON
    this.leaves = JSON.parse(localLeaves); // convert local storage string ot JSON
    this.dressings = JSON.parse(localDressings); // convert local storage string ot JSON  

    if (localBaskets) {
      this.totalCount = this.baskets.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localLeaves) {
      this.totalCount = this.leaves.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localDressings) {
      this.totalCount = this.dressings.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localBaskets && localLeaves) {
      this.totalCount = this.baskets.length + this.leaves.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localBaskets && localDressings) {
      this.totalCount = this.baskets.length + this.dressings.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localLeaves && localDressings) {
      this.totalCount = this.leaves.length + this.dressings.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (localBaskets && localLeaves && localDressings) {
      this.totalCount = this.baskets.length + this.leaves.length + this.dressings.length;
      this.totalCountUpdated.next(this.totalCount);
    }

    if (!localBaskets && !localLeaves && !localDressings) {
      this.totalCount = 0;
      this.totalCountUpdated.next(this.totalCount);
    }
  }

  private snackBarNotification(Message) {
    this.snackBar.open(Message, 'Dismiss', {
      duration: 3000
    })
  }
}
